import { gql } from '@/lib/api';

export interface UsabilityHeatmapPoint {
  page: string;
  module?: string | null;
  selector?: string | null;
  xBucket?: number | null;
  yBucket?: number | null;
  eventType: string;
  interactions: number;
}

export interface UsabilityMetric {
  page: string;
  module?: string | null;
  date: string;
  avgScreenTimeMs: number;
  sessionsCount: number;
  exitSessionsCount: number;
  exitRate: number;
  topNextPage?: string | null;
}

export interface UsabilityMetricsConnection {
  edges: { node: UsabilityMetric; cursor: string }[];
  pageInfo: { hasNextPage: boolean; endCursor?: string | null };
}

export interface UsabilityFilter {
  tenantId: string;
  dateFrom: string;
  dateTo: string;
  page?: string;
  module?: string;
}

const HEATMAP_QUERY = `
  query UsabilityHeatmap($tenantId: ID!, $dateFrom: String!, $dateTo: String!, $page: String, $module: String) {
    usabilityHeatmap(tenantId: $tenantId, dateFrom: $dateFrom, dateTo: $dateTo, page: $page, module: $module) {
      page module selector xBucket yBucket eventType interactions
    }
  }
`;

const METRICS_QUERY = `
  query UsabilityMetrics($tenantId: ID!, $dateFrom: String!, $dateTo: String!, $page: String, $module: String) {
    usabilityMetrics(tenantId: $tenantId, dateFrom: $dateFrom, dateTo: $dateTo, page: $page, module: $module) {
      edges {
        cursor
        node {
          page module date avgScreenTimeMs sessionsCount exitSessionsCount exitRate topNextPage
        }
      }
      pageInfo { hasNextPage endCursor }
    }
  }
`;

export async function getUsabilityHeatmap(filter: UsabilityFilter): Promise<UsabilityHeatmapPoint[]> {
  const data = await gql<{ usabilityHeatmap: UsabilityHeatmapPoint[] }>(HEATMAP_QUERY, {
    ...filter,
  });
  return data.usabilityHeatmap;
}

export async function getUsabilityMetrics(
  filter: UsabilityFilter,
): Promise<UsabilityMetricsConnection> {
  const data = await gql<{ usabilityMetrics: UsabilityMetricsConnection }>(METRICS_QUERY, {
    ...filter,
  });
  return data.usabilityMetrics;
}
